import { Button, CircularProgress } from "@mui/material";
import { red } from "@mui/material/colors";
import { useState } from "react";

type Props = {
  onClick: () => Promise<void> | void;
  disabled?: boolean;
  label?: string;
  blink?: boolean;
};

export const CustomButton = ({
  onClick,
  disabled = false,
  label = "Button",
  blink = false,
}: Props) => {
  const [isLoading, setIsLoading] = useState(false);

  const handleClick = async () => {
    if (isLoading) return;

    setIsLoading(true);
    try {
      const result = onClick();
      if (result instanceof Promise) {
        await result;
      }
    } catch (error) {
      console.error("Button action failed:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const blinkSx = blink
    ? {
        animation: "shipBlink 1s ease-in-out infinite",
        "@keyframes shipBlink": {
          "0%, 100%": { backgroundColor: red[700] },
          "50%": { backgroundColor: red[400] },
        },
        "&:hover": { backgroundColor: red[800] },
      }
    : undefined;

  return (
    <Button
      disabled={disabled || isLoading}
      fullWidth
      size="medium"
      color="primary"
      variant="contained"
      onClick={handleClick}
      sx={blinkSx}
    >
      {isLoading ? <CircularProgress size="1rem" color="inherit" /> : label}
    </Button>
  );
};
